import { render, staticRenderFns } from "./Usuariomain.vue?vue&type=template&id=c8afe21a&scoped=true"
import script from "./Usuariomain.vue?vue&type=script&lang=js"
export * from "./Usuariomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8afe21a",
  null
  
)

export default component.exports